type RowSpacerProps = {
  height: number
  debug?: boolean
}

export const RowSpacer = ({ height, debug }: RowSpacerProps) => {
  return (
    <div
      aria-hidden
      className={debug ? 'border border-red-500' : undefined}
      style={{ height: `${height}rem` }}
    />
  )
}
